module.exports = __webpack_public_path__ + "img/flowers4.aa3d3ce0.jpg";